import { motion } from "framer-motion";
import { Gift, Shield, MapPin, Zap } from "lucide-react";

const ease = [0.22, 1, 0.36, 1];

const items = [
  { id: "free", icon: Gift, title: "Kostenlos & unverbindlich", desc: "Individuelle Angebote für Strom- und Gastarife. Keine versteckten Kosten, Sie entscheiden." },
  { id: "gdpr", icon: Shield, title: "100% DSGVO-konform", desc: "Ihre Daten werden verschlüsselt verarbeitet und niemals an Dritte weitergegeben." },
  { id: "germany", icon: MapPin, title: "Deutschlandweit verfügbar", desc: "Für Privathaushalte und Gewerbekunden in ganz Deutschland – Basis in Herford, NRW." },
  { id: "speed", icon: Zap, title: "24h Express-Angebot", desc: "Schnelle Bearbeitung durch automatisierte KI-Analyse Ihrer Strom- oder Gasrechnung." },
];

const stats = [
  { id: "tariffs", value: "1.000+", label: "Strom- & Gastarife" },
  { id: "time", value: "24h", label: "Bearbeitungszeit" },
  { id: "cost", value: "0 €", label: "Kosten für Sie" },
  { id: "country", value: "DE", label: "deutschlandweit" },
];

export default function TrustSection() {
  return (
    <section
      id="vorteile"
      className="relative py-20 sm:py-28 bg-brand-inverse text-brand-onInverse overflow-hidden grain"
      data-testid="trust-section"
    >
      {/* Ambient green glow */}
      <div aria-hidden className="pointer-events-none absolute -top-40 -left-40 w-[520px] h-[520px] rounded-full bg-brand-energy/20 blur-[120px]" />
      <div aria-hidden className="pointer-events-none absolute -bottom-52 -right-24 w-[560px] h-[560px] rounded-full bg-brand-energy/10 blur-[140px]" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div className="max-w-3xl">
            <p className="text-[11px] font-bold tracking-[0.25em] uppercase" style={{ color: 'var(--brand-green-neon)' }}>Warum Strombaron</p>
            <h2 className="mt-3 font-heading text-4xl sm:text-5xl lg:text-6xl font-black tracking-[-0.035em] leading-[0.95]">
              Vertrauen,<br />auf das Sie bauen können.
            </h2>
          </div>
          <p className="text-base text-neutral-300 max-w-sm md:text-right leading-relaxed">
            Über 1.000 Strom- und Gastarife im Vergleich – transparent, ohne Risiko, für Privat und Gewerbe.
          </p>
        </div>

        {/* Items */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {items.map((it, i) => (
            <motion.div
              key={it.id}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, ease, delay: i * 0.08 }}
              className="group relative bg-white/[0.04] border border-white/10 rounded-3xl p-6 hover:bg-white/[0.08] hover:border-white/30 transition-all duration-300 hover:-translate-y-1"
              data-testid={`trust-item-${it.id}`}
            >
              <div className="w-12 h-12 rounded-2xl bg-brand-energy flex items-center justify-center mb-5 group-hover:shadow-[0_0_28px_0_rgba(0,255,102,0.55)] transition-shadow">
                <it.icon className="w-5 h-5" style={{ color: '#0A0A0A' }} strokeWidth={2.4} />
              </div>
              <h3 className="font-heading text-lg font-black tracking-tight leading-snug">{it.title}</h3>
              <p className="mt-2 text-sm text-neutral-300 leading-relaxed">{it.desc}</p>
            </motion.div>
          ))}
        </div>

        {/* Stat strip */}
        <div className="mt-14 pt-10 border-t border-white/10 grid grid-cols-2 sm:grid-cols-4 gap-6">
          {stats.map((s) => (
            <div key={s.id} className="flex flex-col">
              <span className="font-heading text-4xl sm:text-5xl font-black tracking-tighter leading-none" style={{ color: 'var(--brand-green-neon)' }}>{s.value}</span>
              <span className="mt-2 text-[11px] uppercase tracking-[0.2em] font-semibold text-neutral-400">{s.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
